import React from "react";
import { Box } from "@mui/material";
import { colors } from "../theme/colors";

interface TypingIndicatorProps {
  primaryColor?: string;
}

export const TypingIndicator: React.FC<TypingIndicatorProps> = ({
  primaryColor = colors.primary.main,
}) => {
  return (
    <Box sx={{ display: "flex", gap: 2 }}>
      <Box sx={{ flex: 1 }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 0.5,
            "& .dot": {
              width: 6,
              height: 6,
              borderRadius: "50%",
              backgroundColor: primaryColor,
              animation: "wave 1.4s ease-in-out infinite",
            },
            "& .dot:nth-of-type(1)": {
              animationDelay: "0s",
            },
            "& .dot:nth-of-type(2)": {
              animationDelay: "0.2s",
            },
            "& .dot:nth-of-type(3)": {
              animationDelay: "0.4s",
            },
            "@keyframes wave": {
              "0%, 60%, 100%": {
                transform: "translateY(0)",
                opacity: 0.4,
              },
              "30%": {
                transform: "translateY(-6px)",
                opacity: 1,
              },
            },
          }}
        >
          <Box className="dot" />
          <Box className="dot" />
          <Box className="dot" />
        </Box>
      </Box>
    </Box>
  );
};
